// src/pages/IncomeRecord/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import IncomeRecordFilters from "./components/IncomeRecordFilters";
import IncomeRecordTable from "./components/IncomeRecordTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportIncomeRecordCsv } from "./components/exportIncomeRecordCsv";

const { Title } = Typography;

const IncomeRecord = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list, details, listWithDetails } = useSelector(
    (state) => state.incomeRecord   // 👈 added list, details, listWithDetails
  );
  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Income Record Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportIncomeRecordCsv({
      list,
      details,
      listWithDetails,
      filters,
      title:    "Income Record Report",
      filename: "income_record",
    });
  };

  // mirrors the same dataSource logic used in IncomeRecordTable
  const activeData =
    filters.filterType === "By Income"
      ? details
      : filters.recordType === "with details"
      ? listWithDetails
      : list;

  const hasData = activeData.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={<Title level={4} style={{ margin: 0 }}>Income Record</Title>}
            extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <IncomeRecordFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <IncomeRecordTable />
        </Card>
      </App>

      {/* Print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Income Record Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <IncomeRecordTable pagination={false} printMode />
          )}
        />
      </div>
    </div>
  );
};

export default IncomeRecord;
